import { AppsApi, Configuration, GlobalCitiesApi } from '@coretava/api/core-service';
import { apiClient } from './client';

const config = new Configuration({
  basePath: apiClient.defaults.baseURL || '',
});

export const appsApi = new AppsApi(config, undefined, apiClient);
export const globalCitiesApi = new GlobalCitiesApi(config, undefined, apiClient);
